import { initialOpenModalWithPromise, useOpenModalWithPromise } from '../hooks/useOpenModalWithPromise';
import { Modals } from '../types';
export const useModals = _ref => {
  let {
    setActiveModal,
    onInstallationCompleted
  } = _ref;
  const commonProps = {
    setActiveModal,
    onInstallationCompleted
  };
  const userConsentModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.userConsent
  });
  const upgradeToPremiumModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.upgradeToPremium
  });
  const connectDomainModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.connectDomain
  });
  const siteSelectorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.siteSelector
  });
  const errorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.error
  });
  const businessFirstModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.businessFirst
  });
  const devModalSiteSelectorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.devModeSiteSelector
  });
  return {
    userConsent: userConsentModal,
    upgradeToPremium: upgradeToPremiumModal,
    connectDomain: connectDomainModal,
    siteSelector: siteSelectorModal,
    error: errorModal,
    businessFirst: businessFirstModal,
    devModalSiteSelector: devModalSiteSelectorModal
  };
};
export const initModalsData = {
  userConsent: initialOpenModalWithPromise,
  upgradeToPremium: initialOpenModalWithPromise,
  connectDomain: initialOpenModalWithPromise,
  siteSelector: initialOpenModalWithPromise,
  devModalSiteSelector: initialOpenModalWithPromise,
  error: initialOpenModalWithPromise,
  businessFirst: initialOpenModalWithPromise
};
//# sourceMappingURL=useModals.js.map